// extracted by mini-css-extract-plugin
export var copyableField = "_ra-4";
export var customerBadge = "_ra-0";
export var customerInfoTitle = "_ra-2";
export var details = "_ra-1";
export var dropdownContainer = "_ra-5";
export var dropdownImage = "_ra-6";
export var editAssigneeForm = "_ra-a";
export var editButton = "_ra-3";
export var email = "_ra-7";
export var hidden = "_ra-d";
export var input = "_ra-8";
export var saveButton = "_ra-b";
export var shopifyIcon = "_ra-c";
export var suggestionBadge = "_ra-e";
export var suggestionText = "_ra-f";
export var username = "_ra-9";